import React, { useEffect, useState } from 'react';
import DropdownToggle from 'react-bootstrap/esm/DropdownToggle';
import Dropdown from 'react-bootstrap/esm/Dropdown';
import DropdownMenu from 'react-bootstrap/esm/DropdownMenu';
import DropdownItem from 'react-bootstrap/esm/DropdownItem';
import { useReactToPrint } from 'react-to-print';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import Button from 'react-bootstrap/esm/Button';
import { getPrintConfiguration } from 'core/utils/print';

const marginStylesInput = {
  marginTop: "",
  marginBottom: "",
  marginLeft: "",
  marginRight: "",
}

const Print = ({
  componentRef,
  documentTitle,
  buttonTitle,
  disabled,
  size,
  onBeforeGetContent,
  showOptions = false
}: {
  componentRef: any,
  documentTitle?: string,
  buttonTitle?: string,
  disabled?: boolean,
  size?: "sm" | "lg" | undefined,
  onBeforeGetContent?: () => void | Promise<any>;
  showOptions?: boolean
}) => {

  const [marginStyles, setMarginStyles] = useState<any>(marginStylesInput)

  const handleReactToPrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: documentTitle,
    copyStyles: true,
    onBeforeGetContent: onBeforeGetContent
  })

  const handlePrint = (isLetterHead = false) => {
    const element = document.getElementById("printId");

    // Remove existing style elements if they exist
    const existingStyle = document.getElementById("printStyles");
    if (existingStyle) {
      existingStyle.remove();
    }

    const style = document.createElement("style");
    style.id = "printStyles"; // Give the style element an ID for easy removal

    if (
      isLetterHead &&
      marginStyles?.marginTop !== "" &&
      marginStyles?.marginBottom !== "" &&
      marginStyles?.marginLeft !== "" &&
      marginStyles?.marginRight !== ""
    ) {
      element?.removeAttribute('style');
      style.innerHTML = `@page {
            margin-top: ${marginStyles?.marginTop}px; 
            margin-bottom: ${marginStyles?.marginBottom}px;
            margin-left: ${marginStyles?.marginLeft}px;
            margin-right: ${marginStyles?.marginRight}px;
            border: none !important;
        }`;
    } else {
      element?.removeAttribute('style');
      style.innerHTML = `@page {
            margin-top: 15px; 
            margin-bottom: 15px;
            margin-left: 15px;
            margin-right: 15px;
            border: none !important;
        }`;
    }

    document.body.appendChild(style);
    element?.appendChild(style);
    handleReactToPrint();
  }

  useEffect(() => {
    getPrintConfiguration()
      .then((res) => {
        setMarginStyles({ ...res })
      })
      .catch((err) => {
        console.log(err, "error")
      })
  }, [])

  return (
    <>
      {showOptions ? (
        <Dropdown className='hide-in-print'>
          <DropdownToggle
            variant={disabled ? "secondary" : "primary"}
            size={size}
          >
            {buttonTitle ? buttonTitle :
              <FontAwesomeIcon icon={faPrint} />
            }
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem
              onClick={() => {
                handlePrint(true)
              }}
              disabled={disabled}>
              Letter Head
            </DropdownItem>
            <DropdownItem
              onClick={() => {
                handlePrint()
              }}
              disabled={disabled}>
              Plain Sheet
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      ) : <Button
        variant={disabled ? "secondary" : "primary"}
        size={size}
        disabled={disabled}
        onClick={() => {
          handlePrint(true)
        }}
      >
        {buttonTitle ? buttonTitle :
          <FontAwesomeIcon icon={faPrint} />
        }
      </Button>}
    </>
  );
};

export default Print;